import { http } from 'http';

export default {
  updatePartner: (partnerId, params) => http.put(`/partners/${partnerId}`, params)
};
